import React from 'react';
import PropTypes from 'prop-types';
import { StyledShipperCell, StyledTags, StyledShipperCellContainer } from './ShipperCell.styled';
import { compose, flattenProp } from 'recompose';
import { Tag, Flexer } from '@ontruck/orc';
import ServiceTag, { SKINS } from 'components/ServiceTag';

const t = {
  new: 'FTB',
  prio: 'Prio',
  nonCore: 'RFQ',
};

const enhance = compose(flattenProp('shipper'));

const ShipperCell = React.memo(({ company_name, isNew, isPriority, isCore, ...rest }) => {
  return (
    <StyledShipperCellContainer>
      <StyledShipperCell
        multiline
        title={company_name}
        pRight={(isNew && 'XL') || (isPriority && 'XL')}
        {...rest}
      >
        {company_name}
        <StyledTags>
          <Flexer.Parent flexDirection="column">
            <Flexer.Child>
              {isNew && (
                <Tag skin="modernGrey" weight="bold" textTransform="uppercase">
                  {t.new}
                </Tag>
              )}
            </Flexer.Child>
            <Flexer.Child>
              {isPriority && (
                <Tag skin="priority" weight="bold" textTransform="uppercase">
                  {t.prio}
                </Tag>
              )}
            </Flexer.Child>
            <Flexer.Child>
              {isCore === false && (
                <ServiceTag
                  skin={SKINS.deepPurple}
                  weight="bold"
                  textTransform="uppercase"
                  text={t.nonCore}
                />
              )}
            </Flexer.Child>
          </Flexer.Parent>
        </StyledTags>
      </StyledShipperCell>
    </StyledShipperCellContainer>
  );
});

ShipperCell.propTypes = {
  company_name: PropTypes.string,
  isNew: PropTypes.bool,
  isPriority: PropTypes.bool,
};

export default enhance(ShipperCell);
